import Auth from '../auth/Auth';
import BidPeriodFileGroupInfo from '../models/BidPeriodFileGroupInfo';
import BidPeriodFileImportRequestInfo from '../models/BidPeriodFileImportRequestInfo';
import RequestParameter from "../models/RequestParameter";
import { WebClient } from './WebClient'

class ApiDocument extends WebClient {
    async createFileGroup(groupType: string): Promise<BidPeriodFileGroupInfo | null> {
        let url = `/document/group/${groupType}`;
        return this.post(url, {}, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return null;
        }).catch(() => { return null; });
    }

    async createFileGroupPrevBidPeriod(groupType: string): Promise<BidPeriodFileGroupInfo | null> {
        let url = `/document/group_prev/${groupType}`;
        return this.post(url, {}, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return null;
        }).catch(() => { return null; });
    }

    async createFileGroupWithSubType(groupType: string, subType: string | null): Promise<BidPeriodFileGroupInfo | null> {
        let url = `/document/group/${groupType}`;

        if (!!subType) {
            url = `${url}/${subType}`;
        }
        return this.post(url, {}, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return null;
        }).catch(() => { return null; });
    }

    async createFileGroupWithSubTypePrevBidPeriod(groupType: string, subType: string | null): Promise<BidPeriodFileGroupInfo | null> {
        let url = `/document/group_prev/${groupType}`;

        if (!!subType) {
            url = `${url}/${subType}`;
        }
        return this.post(url, {}, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return null;
        }).catch(() => { return null; });
    }

    async completeFileGroup(groupId: number): Promise<boolean> {
        let url = `/document/group/upstat/${groupId}/Complete`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            return res.status === 200;
        }).catch(() => { return false; });
    }

    async deleteFileGroup(groupId: number): Promise<boolean> {
        let url = `/document/group/${groupId}`;

        return this.delete(url, Auth.getAuthToken()).then(res => {
            return res.status === 200;
        }).catch(() => { return false; });
    }


    async uploadDocuments(groupId: number, data: FormData): Promise<boolean> {
        return this.formPost(`/document/docs/${groupId}`, data, Auth.getAuthToken()).then(res => {
            return (res.status === 200);
        }).catch((err: any) => {
            alert(err); 
            return false;
        });
    }

    async queueServiceRequest(groupType: string): Promise<BidPeriodFileImportRequestInfo> {
        const url = `/document/runsvc/${groupType}`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return;
        }).catch(() => { return; });
    }

    async queueServiceRequestExt(groupType: string, params: RequestParameter[]): Promise<BidPeriodFileImportRequestInfo> {
        const url = `/document/runsvc/${groupType}`;

        return this.post(url, params, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return;
        }).catch(() => { return; });
    }

    async queueEmailServiceRequest(groupType: string, params: RequestParameter[]): Promise<BidPeriodFileImportRequestInfo> {
        const url = `/document/emailsvc/${groupType}`;

        return this.post(url, params, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return;
        }).catch(() => { return; });
    }

    async queueImportRequest(groupId: number): Promise<BidPeriodFileImportRequestInfo> {
        const url = `/document/import/${groupId}`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return;
        }).catch(() => { return; });
    }
}

export default new ApiDocument();
